const Sharing = Object.freeze({
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
  GLOBAL: 'GLOBAL',
  SHARED_WITH_ANALYSTS: 'SHARED_WITH_ANALYSTS',
  SHARED_WITH_COMPANY: 'SHARED_WITH_COMPANY'
})
export default Sharing
// RESERVE BELOW
